import { Injectable } from "@angular/core";
import { ApiRoutes } from "../../../config/api-routes";
import { Observable, of } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Location } from "../model/location";
import { catchError, map } from "rxjs/internal/operators";
import { ApplicationConfig } from "../../../config/application.config";
import { ApplicationType } from "../enums/enums";
import { Building } from "../model/building";
import { BuildingActionsSummary } from '../model/buildingActionsSummary';

@Injectable()
export class BuildingService {
  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {}

  public get(id: string): Observable<Building> {
    return this.httpClient.get<Building>(
      this.apiRoutes.getRouteWithInjectedParams(
        this.apiRoutes.GET_BUILDING_DETAIL,
        [id]
      )
    );
  }

  public getBuildingsWithActions(guid: string): Observable<BuildingActionsSummary[]> {
    return this.httpClient
      .get<any>(this.apiRoutes.GET_BUILDINGS_WITH_ACTIONS, {
        params: new HttpParams().append("interventionTeamId", guid)
      })
      .pipe(
        map(response => response),
        catchError(error => {
          return of([]);
        })
      );
  }

  public getBuildings(guid?: string): Observable<Building[]> {
    const params = guid ? (new HttpParams()).append('interventionTeamId', guid) : null;
    return this.httpClient.get<Building[]>(this.apiRoutes.GET_BUILDINGS, {params});
  }
}
